import { IconsEnum } from '../../../../../../../../../assets/icons/types';
import { Icon } from '../../../../../../../../../helpers/Icon';
import { Translate } from '../../../../../../../../../helpers/Translate';
import { modelViewersKeys } from '../../../../../../../../../locales/keys';
import {
  ModelViewerImageSizeValue,
  modelViewerImageSizes
} from '../../../../modelViewerAspectRatioConstants';
import { DisplaySettingsMenuItem } from '../DisplaySettingsMenuItem';

interface DisplaySettingsResolutionPanelProps {
  imageSize: ModelViewerImageSizeValue;
  onBack: () => void;
  onSelect: (value: ModelViewerImageSizeValue) => void;
}

function DisplaySettingsResolutionPanel({
  imageSize,
  onBack,
  onSelect
}: DisplaySettingsResolutionPanelProps) {
  return (
    <div className="flex flex-col w-full">
      <button
        type="button"
        className="px-1 block w-full group/menu-item"
        role="menuitem"
        onClick={onBack}
      >
        <div className="px-2 py-1 dark:group-hover/menu-item:bg-gray-800 group-hover/menu-item:bg-gray-100 rounded min-h-7">
          <div className="flex items-center gap-2 text-md sm:text-sm">
            <Icon className="h-4 w-4" icon={IconsEnum.CHEVRON_LEFT} />
            <span className="mr-auto font-normal sm:font-medium block truncate leading-5 text-left">
              <Translate id={modelViewersKeys.resolution} />
            </span>
          </div>
        </div>
      </button>
      <hr className="border-gray-200 dark:border-gray-600 my-1" />
      {modelViewerImageSizes.map((value) => (
        <DisplaySettingsMenuItem
          key={value}
          label={value}
          selected={imageSize === value}
          onClick={() => onSelect(value)}
        />
      ))}
    </div>
  );
}

export default DisplaySettingsResolutionPanel;
